import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  FormHelperText,
  Box,
  TextField,
} from "@material-ui/core";
import axios from "axios";
import { Formik } from "formik";
import React, { useContext } from "react";
import { CheckSquare, XCircle } from "react-feather";
import { UsersData } from "src/ContextAPI";
import Notify from "src/notification/Notify";
import * as Yup from "yup";

const ProcessPhilhealth = ({
  patient_id,
  trace_number,
  onClose,
  getallBillForPaymentByPatient,
}) => {
  const { users } = useContext(UsersData);

  const getFormData = (object) => {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  };

  return (
    <>
      <Formik
        initialValues={{
          username: users.username,
          user_id: users.user_id,
          management_id: users.management_id,
          main_mgmt_id: users.main_mgmt_id,
          patient_id: patient_id,
          trace_number: trace_number,
          amount: 0,
        }}
        validationSchema={Yup.object().shape({
          remarks: Yup.string().trim().required("Remarks is required."),
          philhealth: Yup.string().trim().required("philhealth is required."),
          amount: Yup.string().trim().required("amount is required."),
        })}
        onSubmit={async (
          values,
          { setErrors, setSubmitting, resetForm, setFieldValue }
        ) => {
          try {
            const request = await axios.post(
              "billing/admitted/patient/add-philhealth-tobill",
              getFormData(values)
            );

            if (request.data === "success") {
              Notify.successRequest("new patient");
              resetForm();
              onClose();
              getallBillForPaymentByPatient();
            }
          } catch (error) {
            const message = error.message || "Something went wrong";
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          resetForm,
          isSubmitting,
          touched,
          values,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent dividers>
              <Box>
                <TextField
                  error={Boolean(
                    touched.philhealth_caseno && errors.philhealth_caseno
                  )}
                  helperText={
                    touched.philhealth_caseno && errors.philhealth_caseno
                  }
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.philhealth_caseno}
                  fullWidth
                  name="philhealth_caseno"
                  label="Philhealth  Case No"
                  variant="outlined"
                  margin="normal"
                />
              </Box>

              <Box>
                <TextField
                  error={Boolean(touched.philhealth && errors.philhealth)}
                  helperText={touched.philhealth && errors.philhealth}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.philhealth}
                  fullWidth
                  required
                  name="philhealth"
                  label="Philhealth No."
                  variant="outlined"
                  margin="normal"
                />
              </Box>

              <Box>
                <TextField
                  error={Boolean(touched.amount && errors.amount)}
                  helperText={touched.amount && errors.amount}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.amount}
                  fullWidth
                  required
                  name="amount"
                  label="Amount"
                  variant="outlined"
                  margin="normal"
                  type="number"
                  InputProps={{
                    inputProps: {
                      max: 9999999,
                      min: 1,
                      step: 0.01,
                    },
                  }}
                />
              </Box>

              <Box>
                <TextField
                  error={Boolean(touched.remarks && errors.remarks)}
                  helperText={touched.remarks && errors.remarks}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.remarks}
                  fullWidth
                  required
                  name="remarks"
                  label="Remarks"
                  variant="outlined"
                  margin="normal"
                  multiline
                  rows={3}
                />
              </Box>

              {errors.submit && (
                <Box mt={3}>
                  <FormHelperText error>{errors.submit}</FormHelperText>
                </Box>
              )}
            </DialogContent>

            <DialogActions>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                startIcon={
                  isSubmitting ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <CheckSquare />
                  )
                }
                disabled={isSubmitting}
              >
                Save
              </Button>

              <Button
                variant="contained"
                color="default"
                onClick={() => onClose()}
                startIcon={<XCircle />}
              >
                No
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </>
  );
};

export default ProcessPhilhealth;
